import { formatDate_YMD } from "@/_core/_helpers/_helpers";
import { apiService } from "@/_services";
import { timeParseNull2 } from "@/_core/_helpers/_helpers";

/**
 * Fetches future exposure data for a commodity or end product, including valuation for unsettled exposure.
 * @param {object} _this - Context variables, usually the Vue component instance.
 * @param {string} fieldName - Name of the field where the fetched data will be stored.
 * @param {boolean} fieldShowLoadingName - Name of the field that controls the loading state.
 * @param {boolean} [isEndProduct=false] - Determines whether the request is for an end product instead of a commodity.
 */
export function getFutureExposureCommodityData(
  _this,
  fieldName,
  fieldShowLoadingName,
  isEndProduct = false,
) {
  // Set loading state to true before making the request
  _this[fieldShowLoadingName] = true;

  // Define API request parameters
  let params = {
    method: "GET",
    endpoint: "commodity_future_exposure",
    content_type: "application/json",
    query_params: isEndProduct
      ? {
          // If fetching exposure for an end product
          date: formatDate_YMD(new Date()), // Format current date as YMD
          end_product: {
            id_assets: _this.selectedAsset.map((d) => d.pk_id_end_product), // Extract end product IDs from selected assets
          },
          format: "json",
          portfolios: { id_portfolios: _this.portfolioNumbers }, // Include portfolio numbers
        }
      : {
          // If fetching exposure for a commodity
          commodity: _this.commodityNumber, // Use commodity number
          date: formatDate_YMD(new Date()), // Format current date as YMD
          format: "json",
          portfolios: { id_portfolios: _this.portfolioNumbers }, // Include portfolio numbers
        },
  };
  // Send API request
  apiService
    .getAll(params)
    .then((data) => {
      // Ensure data is in a proper format by parsing and deep copying
      data = JSON.parse(JSON.stringify(data));
      // Process each data entry to correctly format date fields
      data.forEach(function(d) {
        d.date = timeParseNull2(d.date);
        d.p_date = timeParseNull2(d.p_date);
        d.sale_date = timeParseNull2(d.sale_date);
      });
      // Store the retrieved data in the specified field
      _this[fieldName] = data;
      // Set loading state to false after data is successfully loaded
      _this[fieldShowLoadingName] = false;
    })
    .catch((error) => {
      // Handle errors and reset loading state
      console.error("Error fetching Future Exposure Commodity Data:", error);
      _this[fieldShowLoadingName] = false;
    });
}
